import React from "react";
import styled from "styled-components";
import { ChevronLeft } from "lucide-react";

interface BackButtonProps {
	onClick: () => void;
	label?: string;
	style?: React.CSSProperties;
	className?: string;
}

const StyledBackButton = styled.button<{ $withLabel: boolean }>`
	border: 0;
	background: ${(props) => (props.$withLabel ? "transparent" : "white")};
	display: flex;
	align-items: center;
	justify-content: center;
	gap: ${(props) => (props.$withLabel ? "4px" : "0")};
	min-width: ${(props) => (props.$withLabel ? "56px" : "auto")};
	padding: ${(props) => (props.$withLabel ? "8px 12px" : "6px")};
	border-radius: 64px;
	cursor: pointer;
	z-index: 1;
	box-shadow: ${(props) => (props.$withLabel ? "none" : "0px 2px 8px rgba(0, 0, 0, 0.05)")};
	transition: all 0.2s ease;
	color: #303030;
	font-family: inherit;
	font-size: 14px;
	font-weight: 500;
	line-height: 24px;

	&:hover {
		background: #f8f9ff;
	}

	> svg {
		color: #303030;
		width: ${(props) => (props.$withLabel ? "8px" : "24px")};
		height: ${(props) => (props.$withLabel ? "14px" : "24px")};
	}
`;

export const BackButton: React.FC<BackButtonProps> = ({ onClick, label, style, className }) => {
	return (
		<StyledBackButton
			type="button"
			$withLabel={Boolean(label)}
			aria-label={label || "Go back"}
			onClick={onClick}
			style={style}
			className={className}
		>
			{label ? (
				<svg viewBox="0 0 8 14" fill="none" aria-hidden>
					<path
						d="M7 1L1.4 7L7 13"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			) : (
				<ChevronLeft />
			)}
			{label}
		</StyledBackButton>
	);
};
